import { all, put, take } from 'redux-saga/effects';

import { PIPEROUTER__NAVIGATION } from 'PipeRouter';

import exitSnippet from './exitSnippet';
import goToCfiPage from './goToCfiPage';
import goToNextPage from './goToNextPage';
import goToPreviousPage from './goToPreviousPage';
import getNavigationInfo from './getNavigationInfo';


function* main() {
  while (true) {
    const { data:{ cmd, data }} = yield take(PIPEROUTER__NAVIGATION);

    yield put({ type: cmd, data });
  }
};

function* navigation() {
  yield all([
    main(),
    exitSnippet(),
    goToCfiPage(),
    goToNextPage(),
    goToPreviousPage(),
    getNavigationInfo()
  ]);
}


export default navigation;
